import { useSeo } from '@/lib/seo';

export default function TermsPage() {
  useSeo({ title: 'Terms | A Guy Who Hunts', description: 'Terms of use for aguywhohunts.com.' });
  return (
    <div className="mx-auto max-w-[72ch] px-4 sm:px-6 lg:px-8 py-16 prose-editorial">
      <p className="kicker">Terms</p>
      <h1 className="font-serif text-4xl tracking-tight mt-2">Terms of Use</h1>
      <p>
        A Guy Who Hunts is a personal documentary project. Content on this site is provided for informational and
        entertainment purposes and does not constitute hunting, legal, or safety advice.
      </p>
      <p>
        Always follow the laws and regulations of the state, province, or country where you hunt. Practice safe firearm
        and archery handling and respect the land you use.
      </p>
    </div>
  );
}
